import { Color } from "@material-ui/lab";
import { SnackbarAlert } from "app/components/ui/alert/SnackbarAlert";
import { createContext, FC, useCallback, useContext, useState } from "react";
import { SnackbarContainer } from "./snackbar-container";

export type SnackbarKey = string | number;
export type SnackbarMessage = string | React.ReactNode;
export interface Snack {
  key: SnackbarKey;
  title: string;
  message?: string;
  html?: string;
  timeout?: number;
  severity: Color;
}
interface State {
  snacks: Snack[];
}
export interface ProviderContext {
  state: any;
  setState: any;
}

// @ts-ignore
export const SnackbarContext = createContext<ProviderContext>();

export const SnackbarProvider: FC = ({ children }: any) => {
  const [state, setState] = useState<State>({
    snacks: [],
  });

  const snackbars = (
    <SnackbarContainer>
      {state.snacks.map((snack) => (
        <SnackbarAlert
          key={snack.key}
          snackKey={snack.key}
          title={snack.title}
          message={snack.message || ''}
          html={snack.html || ''}
          timeout={snack.timeout}
          severity={snack.severity}
        />
      ))}
    </SnackbarContainer>
  );

  return (
    <SnackbarContext.Provider value={{ state, setState }}>
      {children}
      {snackbars}
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  const { setState } = useContext<any>(SnackbarContext);

  const openSnackbar = useCallback(
    (
      {
        title,
        message,
        html,
        severity,
        timeout,
      }: {
        html?: Snack["html"];
        message?: Snack["message"];
        title: Snack["title"];
        timeout?: Snack["timeout"];
        severity: Snack["severity"];
      },
      key: Snack["key"] = new Date().getTime() + Math.random()
    ): SnackbarKey => {
      const snack: Snack = {
        key,
        title,
        message,
        html,
        severity,
        timeout,
      };

      setState(
        (state: State): State => ({
          ...state,
          snacks: [...state.snacks, snack],
        })
      );

      return key;
    },
    [setState]
  );

  const closeSnackbar = useCallback(
    (key: SnackbarKey): void => {
      setState(
        (state: State): State => ({
          ...state,
          snacks: state.snacks.filter((item) => item.key !== key),
        })
      );
    },
    [setState]
  );

  return {
    closeSnackbar,
    openSnackbar,
  };
};
